import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import EntryGrid from "./components/EntryGrid";
import ExploreCards from "./components/ExploreCards";
import Channels from "./components/Channels";
import Guide from "./components/Guide";
import UpdatesFaq from "./components/UpdatesFaq";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <EntryGrid />
        <ExploreCards />
        <Channels />
        <Guide />
        <UpdatesFaq />
      </main>
      <Footer />
    </>
  );
}